import { AppType } from '@repo/types';

export const useAppType = (): AppType => {
  const appType = (import.meta as unknown as { env: { VITE_APP_TYPE: string } })
    .env.VITE_APP_TYPE;
  return appType as AppType;
};
